<template>

  <div>
    <van-nav-bar
      fixed
      title="销售出库"
      left-arrow
      @click-left="onClickLeft"
    />

    <div id="aaa"></div>

    <van-cell-group title="影像中心" :border="false" style="margin-left: 10px;">
      <van-cell icon="location-o" :title="currentAgent.name" is-link to="pwalist" style="border-bottom:0.1px solid 	#F5F5F5"/>
    </van-cell-group>

    <van-cell-group title="客户" :border="false" style="margin-left: 10px;">
      <van-cell icon="location-o" :title="customerInfo.name" is-link @click = "toCustomerList" style="border-bottom:0.1px solid 	#F5F5F5"/>
    </van-cell-group>

    <van-cell-group  title="备注" :border="false">
      <van-cell  icon="edit" style="border-bottom:0.1px solid 	#F5F5F5">
        <van-field
          v-model="message"
          rows="2"
          autosize
          type="textarea"
          maxlength="50"
          placeholder="销售出库"
          show-word-limit
          @click="input_click"
          @blur='input_blur'
          />
      </van-cell>
    </van-cell-group>
      
    <van-cell-group title="出库明细" :border="false">

      <van-cell  class="box">
      <van-swipe-cell v-for="(item,index) in outStockDetail" :key="index"
                      :class="{selecteddetail:defaultDetail==index}" @click="toggleDetail(index)">
        <van-cell-group :border="false">
          <van-cell  class="detailcell" >
            <van-row class="ha" type="flex" justify="space-between">
              <van-col span="22"><span style="#323233!important"></span>{{item.modelname}}</van-col>
              <van-col span="2"><van-icon name="search" @click="tokclist(index)" size="20px"/></van-col>
            </van-row>
            <van-row type="flex" >
              <van-col span="24"><span style="color:#969799">库存数量:</span> {{item.quantity + item.unit}}</van-col>
            </van-row>
            <van-row type="flex" justify="space-between">
              <van-col span="20"><span style="color:#969799">出库数量:</span><input type="text" style="width:70%;border:none" v-model="item.count"  @click="input_click" @blur='input_blur'/></van-col>
              <!--<van-col span="4"><van-image round width="0.8rem" height="0.8rem" src="/img/del.png" @click="del(index)"/></van-col>-->
            </van-row>
            <van-row type="flex">
              <van-col span="24"><span style="color:#969799">出库仓库:</span>
                  <van-tag plain type="danger" size="large" color="#838683"  v-if="item.warehousename">{{item.warehousename}}</van-tag>
                </van-col>
            </van-row>
          </van-cell>
        </van-cell-group>
          <van-button style="height: 100%;"
            slot="right"
            square
            text="删除"
            type="danger"
            class="delete-button"
            @click="del(index)"
          />

      </van-swipe-cell>
      </van-cell>
      <van-cell>
        <van-icon name="add-o" color="#07c160"  size="40" @click="add"  style="float:right"/>
      </van-cell>
    </van-cell-group>
    <van-cell-group>
      <van-cell>
        <van-button type="info" style="font-size: 0.47333rem;background: #30cca8;border-radius: 50px;border: 0.02667rem solid #30cca8;font-weight:bold" @click="qr">提交出库</van-button>
      </van-cell>
    </van-cell-group>
    <!--<div id="add">-->
      <!--<van-image round width="0.8rem" height="0.8rem" src="/img/add.png" @click="add"/>-->
    <!--</div> -->
    <div v-show='bottom_tip' style="font-size:10px;text-align:center;padding:10px 10px">©2020 一脉阳光集团信息中心</div>

  </div>
</template>

<script>
import { SwipeCell,NavBar  , Tag , DropdownMenu, DropdownItem ,Col, Row ,Panel,Divider,Button,Dialog, Icon,Image,Toast } from 'vant';
import {mapState,mapMutations} from 'vuex';
export default {
  components:{
    [NavBar.name]:NavBar,
    [Tag.name]:Tag,
    [Toast.name]:Toast,
    [DropdownMenu.name]:DropdownMenu,
    [DropdownItem.name]:DropdownItem,
    [Col.name]:Col,
    [Icon.name]:Icon,
    [Image.name]:Image,
    [Button.name]:Button,
    [Dialog.Component.name]: Dialog.Component,
    [Panel.name]:Panel,
    [Divider.name]:Divider,
    [Row.name]:Row,
    [SwipeCell.name]:SwipeCell
  },
  data(){
    return{
      message:"",
      bottom_tip:true,
      defaultDetail:0,
      customerInfo:{
        name:''
      },
      //当前选中的影像中心
      currentAgent:''
    }
  },
  methods: {
    ...mapMutations(['changePermissionAgent','changeDefaultAgentIndex','changeOutStockDetail']),
    onClickLeft() {
      this.$router.push("/index")
    },
    toCustomerList() {
      this.$router.push({
        name:"customerlist",
        query:{
          from:'sale',
          message:this.message
        }
      })
    },
    tokclist(index) {
      this.$router.push({
        name:"stockinfo",
        query:{
          from:'sale',
          index:index,
          message:this.message
        }
      })
    },
    parseSubmitData(obj) {
      let newarr = [];
      let message= '';
      for(let i=0;i<obj.length;i++) {
        if (obj[i].count && obj[i].count > obj[i].quantity) {
          let num = i + 1;
          message = message + "第" + num + "条明细,出库数量不能超过库存数量！\n";
        }
        if (!obj[i].count) {
          let num = i + 1;
          message = message + "第" + num + "条明细,出库数量为空\n";
        }
        let newobj = {
          stockID:obj[i].stockID,
          warehouseId:obj[i].warehouseId,
          purchaseOrderNum:0,
          purchaseOrderDetailId:0,
          branduuid:obj[i].branduuid,
          modeluuid:obj[i].modeluuid,
          unit:obj[i].unit,
          unitcost:obj[i].unitcost,
          quantity:obj[i].count
        }
        newarr.push(newobj);
      }
      return {
        message:message,
        data:newarr
      }
    },
    qr() {
      let that = this;
      Dialog.confirm({ 
        message: '确认提交出库'
      }).then(() => {
        if(!this.message) {
            Toast('请输入备注信息');
          return;
        }
        if(!this.outStockDetail[0]) {
            Toast('明细不能为空');
          return;
        }
        let result = this.parseSubmitData(this.outStockDetail);
        // window.console.log(result);
        if(result.message) {
            Toast(result.message);
          return;
        } else {
          
          let data = {
            remark:this.message,
            creater:localStorage.getItem("workcode"),
            projectErpCode:this.currentAgent.erp_code,
            detail:result.data
          }
          //window.console.log(data);
          Toast.loading({
              message: '加载中...',
              forbidClick: true
          });
          //window.console.log(data);
          this.$http({
            method:'post',
            url:'/mobile/stockOut',
            data
          }).then(function (response) {
            Toast.success('出库成功');
            window.console.log(response);
            that.$router.push("index")
          });
        }
      }).catch(() => {
        alert(2222);
      });
    },
    del(index){
      let obj = {
        index,
        operator:'del'
      };
      this.$store.commit('changeOutStockDetail',obj);
    },
    add(){
      let obj = {
        operator:'add'
      };
      this.changeOutStockDetail(obj);
    },
    toggleDetail(index) {
      this.defaultDetail = index;
    },
    input_click: function() {
        this.bottom_tip =false;
    },
    input_blur() {
        setTimeout(() => {
            this.bottom_tip = true;
        }, 300);
    }
    
  },
  computed:{
    ...mapState(['permissionAgent','defaultAgentIndex','outStockDetail']),
  },
  beforeRouteEnter (to, from, next) {
    if (from.name == 'stockinfo') {
      next(vm => {
        if (vm.$route.params.modelname!=null) {
          let info = {
            operator :'update',
            index:vm.$route.params.index,
            modelname:vm.$route.params.modelname,
            warehousename:vm.$route.params.warehousename,
            quantity:vm.$route.params.quantity,
            stockID:vm.$route.params.stockID,
            warehouseId:vm.$route.params.warehouseId,
            branduuid:vm.$route.params.branduuid,
            modeluuid:vm.$route.params.modeluuid,
            unit:vm.$route.params.unit,
            unitcost:vm.$route.params.unitcost,
          }
          vm.defaultDetail = vm.$route.params.index;
          vm.message = vm.$route.params.message;
          vm.changeOutStockDetail(info);
        }
      })
    } else {
      next(vm => {
        let clearall = {
          operator:'clearall'
        }
        vm.changeOutStockDetail(clearall);
      })
    }
    
  },
  created() {
    if (this.permissionAgent) {
      let _this = this;
      this.currentAgent = this.permissionAgent.find(function(item) {
        // window.console.log(state.defaultAgentIndex);
        return item.id == _this.defaultAgentIndex;
      });
    } else {
      let _this = this;
      this.$http.post('/mobile/rimsAgentList',{
        username:localStorage.getItem('usermobile')
      }).then(function (response) {
        window.console.log(response);
        _this.changePermissionAgent(response.rimsAgent);
        _this.changeDefaultAgentIndex(response.rimsAgent[0].id);
        _this.currentAgent = _this.permissionAgent.find(function(item) {
        // window.console.log(state.defaultAgentIndex);
          return item.id == _this.defaultAgentIndex;
        });
      })
      
    }
  }
}
</script>
<style scoped lang="less">

.van-nav-bar{
  background: #ffffff;color:#323233;font-weight: bold;
  /*background: #456;*/
  /*color:white;*/
}
.van-nav-bar__title{
  font-weight: 800;
  color:#323233;
}
.van-nav-bar .van-icon{
  color:black;
}
.ha {
  border-bottom: 0.2px solid 	#DCDCDC	
}
.box{
  background-color: #fff;
}


.van-button {
        width:100%;
}
#aaa{
  width:100vw;
  height:46px;
}
#add{
  position: fixed;
  top:300px;
  right:0;
}
.van-cell-group__title{
  color:#323233!important;
  font-weight: bold;
  font-size: 0.38rem;
  background-color: #f7f8fa;
}
.van-cell{
  color:#969799!important;
}
.van-tag--danger.van-tag--plain{
  color: rgb(131, 134, 131);
}
  .detailcell{
    line-height: 1rem!important;
    border: 1px solid #dadae4;
    margin-bottom: 10px;
    background: #f7f8fa;
  }
</style>